import { Vue, newVue } from '@/config/vue'

const init = () => {
  const FlashMessages = Vue.component('flash-messages', () =>
    import(/* webpackChunkName: "flash-messages" */ './FlashMessages.vue')
  )
  newVue({
    render: h => h(FlashMessages),
    mount: '.js-vue-flash-message',
  })
}

On.VueInit({
  init({ isSpa }) {
    if (!isSpa) init()
  },
})
